import React from 'react';
import Accordion from '@components/common/Accordion/Accordion';

export type FaqItemProps = {
  title: string;
  content: string;
};

export default function FaqItem({ title, content }: FaqItemProps) {
  return (
    <Accordion classes="border-b border-rp-primary-redesign">
      <Accordion.Title
        buttonClass="w-full text-left text-base px-4 py-2 text-rp-shadow"
        isArrowBlack
      >
        <p>{title}</p>
      </Accordion.Title>
      <Accordion.Content>
        <p
          className="text-base px-4 py-4 font-rp-basetica-light text-rp-primary-black"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Accordion.Content>
    </Accordion>
  );
}
